import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { businessApi } from '../../api/businessApi';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-hot-toast';

export default function CreateBusinessModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({ name: '', type: 'retail', address: '' });
  const [loading, setLoading] = useState(false);
  const { loadBusinesses } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await businessApi.createBusiness(formData);
      if (res.data.success) {
        toast.success('Business created successfully!');
        await loadBusinesses(); // Reload businesses to get the new one
        onClose();
        setFormData({ name: '', type: 'retail', address: '' });
      }
    } catch (err) {
      if (err.response?.data?.upgradeRequired) {
        onClose();
      } else {
        toast.error(err.response?.data?.message || 'Failed to create business');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="relative z-50">
      <div className="fixed inset-0 bg-black/30 dark:bg-black/50 backdrop-blur-sm" aria-hidden="true" />
      
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div className="mx-auto max-w-sm w-full bg-white dark:bg-gray-900 rounded-2xl shadow-xl overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 dark:border-gray-800 flex items-center justify-between">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Create New Khata</h2>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300">
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>
          
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Business Name *</label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-[#dc343b] outline-none transition-shadow"
                placeholder="E.g. My Second Shop"
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Business Type</label>
              <select
                value={formData.type}
                onChange={(e) => setFormData({...formData, type: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-[#dc343b] outline-none transition-shadow"
              >
                <option value="retail">Retail</option>
                <option value="wholesale">Wholesale</option>
                <option value="service">Service</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Address (Optional)</label>
              <input
                type="text"
                value={formData.address}
                onChange={(e) => setFormData({...formData, address: e.target.value})}
                className="w-full px-4 py-2 border border-gray-300 dark:border-gray-700 rounded-xl bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-[#dc343b] outline-none transition-shadow"
                placeholder="Shop address"
              />
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#dc343b] text-white py-2.5 rounded-xl font-bold hover:bg-red-700 active:bg-red-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Creating...' : 'Create Khata'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
